import { useSetAtom } from 'jotai';

import usePdpSelectedCustomizerTabAtom from './usePdpSelectedCustomizerTabAtom';

const useSetPdpSelectedCustomizerTab = () => {
  const pdpSelectedCustomizerTabAtom = usePdpSelectedCustomizerTabAtom();
  const setPdpSelectedCustomizerTab = useSetAtom(pdpSelectedCustomizerTabAtom);

  return setPdpSelectedCustomizerTab;
};

export default useSetPdpSelectedCustomizerTab;
